import { Component, ChangeDetectionStrategy } from '@angular/core';

const PLUGS_LENGTH = 10;

@Component({
  selector: 'prlw-all-table-loading-ui',
  templateUrl: './loading-all-table.component.html',
  styleUrls: ['./loading-all-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingAllTableComponent {
  public readonly loaderPlugsLength = [...Array(PLUGS_LENGTH)];
}
